import { render, staticRenderFns } from "./test copy.vue?vue&type=template&id=5221daea"
import script from "./test copy.vue?vue&type=script&lang=js"
export * from "./test copy.vue?vue&type=script&lang=js"
import style0 from "./test copy.vue?vue&type=style&index=0&id=5221daea&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports